import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    // Allow only digits and a single decimal point
    let filtered = input.value.replace(/[^\d.]/g, '');
    // Prevent more than one decimal point
    const parts = filtered.split('.');
    if (parts.length > 2) {
      filtered = parts[0] + '.' + parts.slice(1).join('');
    }
    if (input.value !== filtered) {
      input.value = filtered;
      this.ngControl.control?.setValue(filtered);
    }
  }
}

/**
 * Directive to allow numeric input with up to two decimal places.
 * Usage: add attribute `appTwoDecimal` to an input (e.g. <input appTwoDecimal>)
 */
@Directive({
  selector: '[appTwoDecimal]'
})
export class TwoDecimalDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    // Remove any character that's not digit or dot
    let val = input.value.replace(/[^\d.]/g, '');
    // If multiple dots, keep the first one only
    const parts = val.split('.');
    if (parts.length > 1) {
      const intPart = parts.shift();
      let decPart = parts.join('');
      // limit decimal part to 2 digits
      decPart = decPart.substring(0, 2);
      val = intPart + '.' + decPart;
    }

    // prevent leading zeros like 00 => 0
    if (/^0\d+/.test(val) && !/^0\./.test(val)) {
      val = String(Number(val));
    }

    if (input.value !== val) {
      input.value = val;
      this.ngControl.control?.setValue(val);
    }
  }
}
@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement): void {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.clickOutside.emit();
    }
  }
}
export const COMMON_DIRECTIVES = [ClickOutsideDirective,OnlyNumberDirective, TwoDecimalDirective];

// You can add more common directives here for easy maintenance and usage
